import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";

export const prabhMoheKabGal: CompositionDetails = {
    id: compositionIds.prabhMoheKabGal,
    media: {
        youtubeVideoId: "Usoi9mDh4Do",
    },
    displayName: "Prabh Mohe Kab Gal Lavehege - Harjinder Singh Ji",
    taals: ["kehrava"],
};
